'use client'

import { Spacer, Text } from '@vinted/web-ui'

import { navigateToPage } from '@marketplace-web/shared/browser-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'
import {
  itemAttributesClickEvent,
  ItemPageSummaryPluginModel,
  SummaryLineModel,
  SummaryNavigationalElementModel,
  SummaryTextElementModel,
} from '@marketplace-web/item-page/item-page-data'

const ItemPageSummaryPlugin = ({ lines, itemId }: ItemPageSummaryPluginModel) => {
  const { track } = useTracking()

  const onNavigationTextClick = (element: SummaryNavigationalElementModel) => () => {
    track(
      itemAttributesClickEvent({
        itemId: itemId.toString(),
        attributeCode: element.code,
        attributeValueId: element.id.toString(),
      }),
    )
    navigateToPage(element.url)
  }

  const renderSpacer = () => (
    <>
      <Spacer orientation={Spacer.Orientation.Vertical} size={Spacer.Size.Small} as="span" />
      <Text as="span" text="&middot;" type={Text.Type.Body} />
      <Spacer orientation={Spacer.Orientation.Vertical} size={Spacer.Size.Small} as="span" />
    </>
  )

  const renderElement = (
    element: SummaryTextElementModel | SummaryNavigationalElementModel,
    index: number,
  ) => {
    if (element.type === 'text') {
      return (
        <Text
          key={`element-${index}`}
          text={element.value}
          type={element.style}
          as={element.style === Text.Type.Title ? 'h1' : 'span'}
        />
      )
    }
    if (element.type === 'navigational') {
      return (
        <a href={element.url} onClick={onNavigationTextClick(element)} key={`element-${index}`}>
          <Text clickable text={element.value} type={element.style} as="span" />
        </a>
      )
    }

    return null
  }

  const renderLine = (line: SummaryLineModel, lineIndex: number) => {
    return (
      <div key={`summary-line-${lineIndex}`} className={`summary-max-lines-${line.maxLines}`}>
        <SeparatedList separator={renderSpacer()}>
          {line.elements.map(renderElement).filter(element => element !== null)}
        </SeparatedList>
      </div>
    )
  }

  return (
    <div data-testid="item-page-summary-plugin">
      {lines.map(renderLine)}
      <Spacer size={Spacer.Size.Large} />
    </div>
  )
}

export default ItemPageSummaryPlugin
